import { graphql } from 'relay-runtime';

export const updateTimeInputCreateEstimateMutationShard = graphql`
  mutation updateTimeInputCreateEstimateMutation($connections: [ID!]!, $input: EstimateCreateInput!) {
    createEstimate(input: $input) @appendEdge(connections: $connections) {
      node {
        id
        estimate
        insertedAt
      }
    }
  }
`;
